module.exports = __webpack_public_path__ + "static/media/ws06.abe4a99e.webp";